import axios from "axios";


const dataRequest = async (inspectionId: string, section: string, user: any = null) => {
    const url = process.env.REACT_APP_IDWAL_API_URL + "/Inspection/" + section + "/" + inspectionId;
    const token = user.signInUserSession.idToken.jwtToken;

    return axios.get(url, {
        headers: {
            "Authorization": "Bearer " +  token
        }
    }).then(result => {
        return result.data
    });
}

export default dataRequest;

